
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/microdeposits",
      function () {
        return require("private-next-pages/link-demo/microdeposits.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/microdeposits"])
      });
    }
  